import React from 'react';
import { getCurrentUserRoleLabel, getCurrentUserRoleLabelShort } from '../../utils/roleLabels';

const UserRoleBadge = ({ className = '' }) => {
  const label = getCurrentUserRoleLabel();
  const short = getCurrentUserRoleLabelShort();
  if (!label) return null;
  return (
    <span className={`cs-role-badge ${className}`} title={`Signed in as ${label}`}>
      <span className="cs-role-badge-dot" />
      <span className="cs-role-badge-text cs-role-badge-full">{label}</span>
      <span className="cs-role-badge-text cs-role-badge-short">{short}</span>
    </span>
  );
};

export default UserRoleBadge;
